import {type CurrencyFormatter} from 'platform/locale';

import {isNil} from 'ramda';

// Pkw-EnVKV amounts are always quoted in EUR by the German regulation.
const PKW_ENVKV_CURRENCY = 'EUR';

// Number('') and Number('   ') are 0, so blank strings need their own check;
// Number.isFinite rejects NaN as well as 'Infinity'.
const isDecimalString = (value: string) => value.trim() !== '' && Number.isFinite(Number(value));

/**
 * Formats a backend decimal string as an EUR amount, keeping exactly the number
 * of decimal places the backend sent ('0.39' → two, '2415' → none) unless
 * `fractionDigits` fixes them. Blank or non-numeric data is not an amount and
 * yields `undefined`.
 */
export const formatEnvkvCurrency = (
  formatCurrency: CurrencyFormatter,
  value: string | null | undefined,
  fractionDigits?: number
) =>
  isNil(value) || !isDecimalString(value)
    ? undefined
    : formatCurrency(
        Number(value),
        PKW_ENVKV_CURRENCY,
        fractionDigits ?? value.split('.')[1]?.length ?? 0
      );
